<router-outlet></router-outlet>
<ng-container *ngIf="route.children.length === 0">
    <div class="row">
        <div class="col-xs-12 col-md-6">
            <div class="card">
                <div class="content">
                    <ng-container [ngSwitch]="state">
                        <!-- Initial -->
                        <ng-container *ngSwitchCase="eWorkflowState.INITIAL">
                            <div class="text-left p-bottom-5">
                                <h4 class="m-top-0 m-bottom-0">Connect to Vincere</h4>
                            </div>

                            <div class="text-left">
                                <span>Once connected - we will source data from Vincere API with users statistics.</span>
                                <span class="m-right-5"></span>
                                <a target="_blank"
                                   href="https://help.frankli.io/en/articles/5988934-vincere-integration">Learn
                                    more </a>
                            </div>

                            <div class="text-center p-top-20">
                                <button class="btn-frankli-round btn-frankli-green" [disabled]="loadingSetup"
                                        (click)="startSetup()">
                                    <span>Setup Vincere</span>
                                    <span *ngIf="loadingSetup" class="m-left-10 fal fa-spin fa-spinner fa-fw"></span>
                                </button>
                            </div>
                        </ng-container>

                        <!-- Set up -->
                        <ng-container *ngSwitchCase="eWorkflowState.SETUP">
                            <div class="text-left p-bottom-5">
                                <h4 class="m-top-0 m-bottom-0">Connect to Vincere</h4>
                            </div>

                            <div class="p-bottom-20">
                                <span>In order to connect Frankli with Vincere, you need to provide your Vincere API details.</span>
                                <span class="m-right-5"></span>
                                <a target="_blank"
                                   href="https://help.frankli.io/en/articles/5988934-vincere-integration">Learn more</a>
                            </div>

                            <div class="frankli-form-group frankli-form-group-filled frankli-form-group-placeholder-shown"
                                 [class.frankli-form-group-invalid]="setupSubmitted && (controlTenantId.invalid)">
                                <label for="setupTenantId">Tenant Id</label>
                                <input id="setupTenantId" placeholder="name.vincere.io" class="form-control" type="text"
                                       [formControl]="controlTenantId">
                                <div class="frankli-form-group-alert">
                                    <ng-container *ngIf="controlTenantId.invalid && setupSubmitted">
                                        <div *ngIf="controlTenantId.hasError('required')">Tenant Id is required</div>
                                        <div *ngIf="controlTenantId.hasError('maxlength')">Tenant Id is too long</div>
                                    </ng-container>
                                </div>
                            </div>

                            <div class="frankli-form-group frankli-form-group-filled frankli-form-group-placeholder-shown"
                                 [class.frankli-form-group-invalid]="setupSubmitted && (controlKey.invalid || setupApiKeyInvalid)">
                                <label for="setupKey">API Key</label>
                                <input id="setupKey" placeholder="Paste API Key here" class="form-control" type="text"
                                       [formControl]="controlKey">
                                <div class="frankli-form-group-alert">
                                    <ng-container *ngIf="(controlKey.invalid || setupApiKeyInvalid) && setupSubmitted">
                                        <div *ngIf="controlKey.hasError('required')">API Key is required</div>
                                        <div *ngIf="setupApiKeyInvalid">{{setupApiKeyInvalid}}</div>
                                    </ng-container>
                                </div>
                            </div>

                            <div class="frankli-form-group frankli-form-group-filled frankli-form-group-placeholder-shown"
                                 [class.frankli-form-group-invalid]="setupSubmitted && (controlClientId.invalid || setupClientIdInvalid)">
                                <label for="clientId">Client Id</label>
                                <input id="clientId" placeholder="Paste Client Id here" class="form-control" type="text"
                                       [formControl]="controlClientId">
                                <div class="frankli-form-group-alert">
                                    <ng-container
                                            *ngIf="(controlClientId.invalid || setupApiKeyInvalid) && setupSubmitted">
                                        <div *ngIf="controlClientId.hasError('required')">Client Id is required</div>
                                        <div *ngIf="setupClientIdInvalid">{{setupClientIdInvalid}}</div>
                                    </ng-container>
                                </div>
                            </div>

                            <div class="text-center">
                                <button class="btn-frankli-round btn-frankli-green" [disabled]="setupCompleting"
                                        (click)="saveApiKey()">
                                    <span>Save</span>
                                    <span *ngIf="setupCompleting" class="m-left-10 fal fa-spin fa-spinner fa-fw"></span>
                                </button>
                            </div>
                        </ng-container>

                        <!-- Complete -->
                        <ng-container *ngSwitchCase="eWorkflowState.UPDATE_REFRESH_TOKEN"
                                      [ngTemplateOutlet]="stateUpdate"></ng-container>
                        <ng-container *ngSwitchCase="eWorkflowState.COMPLETE"
                                      [ngTemplateOutlet]="stateUpdate"></ng-container>

                        <ng-template #stateUpdate>
                            <div class="text-left p-bottom-5">
                                <div class="container-api-heading">
                                    <h4 class="m-top-0 m-bottom-0">Vincere API information</h4>
                                    <button class="btn-frankli-round btn-frankli-small btn-frankli-green-inverted"
                                            (click)="startUpdate()">
                                        <span class="fal fa-fw fa-edit"></span>
                                        <span>Edit</span>
                                    </button>
                                </div>
                            </div>

                            <div class="p-bottom-20">
                                <span>We will try and connect to Vincere using the details below.</span>
                                <span class="m-right-5"></span>
                                <a target="_blank"
                                   href="https://help.frankli.io/en/articles/5988934-vincere-integration">Learn more</a>
                            </div>

                            <div class="frankli-form-group frankli-form-group-filled"
                                 [class.frankli-form-group-invalid]="token && token.error">
                                <label for="tenantId">Tenant Id</label>
                                <input id="tenantId" disabled class="form-control" type="text"
                                       [value]="token!.tenantId">
                                <div class="frankli-form-group-alert"></div>
                            </div>

                            <div class="frankli-form-group frankli-form-group-filled"
                                 [class.frankli-form-group-invalid]="token && token.error">
                                <label for="apiKey">API Key</label>
                                <input id="apiKey" disabled class="form-control" type="text" [value]="token!.apiKey">
                                <div class="frankli-form-group-alert"></div>
                            </div>
                            <div class="frankli-form-group frankli-form-group-filled"
                                 [class.frankli-form-group-invalid]="token && token.error">
                                <label for="clientId">Client Id</label>
                                <input id="clientId" disabled class="form-control" type="text"
                                       [value]="token!.clientId">
                                <div class="frankli-form-group-alert"></div>
                            </div>
                            <div class="frankli-form-group-alert">
                                <div *ngIf="token && token.error">{{token!.error}}</div>
                            </div>
                            <div *ngIf="token!.connected">
                                <p>
                                    <span class="m-right-5"></span>
                                    <app-check></app-check>
                                    <span class="m-left-5">Connected to Vincere</span>
                                </p>
                            </div>
                        </ng-template>

                        <!-- Update API Key -->
                        <ng-container *ngSwitchCase="eWorkflowState.UPDATE_API_KEY">
                            <div class="text-left p-bottom-5">
                                <h4 class="m-top-0 m-bottom-0">Update API Key</h4>
                            </div>

                            <div class="p-bottom-20">
                                <span>In order to connect Frankli with Vincere, you need to provide your Vincere API details.</span>
                                <a target="_blank"
                                   href="https://help.frankli.io/en/articles/5988934-vincere-integration">Learn more</a>
                            </div>

                            <div class="frankli-form-group frankli-form-group-filled frankli-form-group-placeholder-shown"
                                 [class.frankli-form-group-invalid]="setupSubmitted && (controlTenantId.invalid)">
                                <label for="setupTenantId">Tenant Id</label>
                                <input id="setupTenantId" placeholder="[name].vincere.io" class="form-control"
                                       type="text" [formControl]="controlTenantId">
                                <div class="frankli-form-group-alert">
                                    <ng-container *ngIf="controlTenantId.invalid && setupSubmitted">
                                        <div *ngIf="controlTenantId.hasError('required')">Tenant Id is required</div>
                                        <div *ngIf="controlTenantId.hasError('maxlength')">Tenant Id is too long</div>
                                    </ng-container>
                                </div>
                            </div>

                            <div class="frankli-form-group frankli-form-group-filled frankli-form-group-placeholder-shown"
                                 [class.frankli-form-group-invalid]="setupSubmitted && (controlKey.invalid || setupApiKeyInvalid)">
                                <label for="setupKey">API Key</label>
                                <input id="setupKey" placeholder="Paste API Key here" class="form-control" type="text"
                                       [formControl]="controlKey">
                                <div class="frankli-form-group-alert">
                                    <ng-container *ngIf="(controlKey.invalid || setupApiKeyInvalid) && setupSubmitted">
                                        <div *ngIf="controlKey.hasError('required')">API Key is required</div>
                                        <div *ngIf="setupApiKeyInvalid">{{setupApiKeyInvalid}}</div>
                                    </ng-container>
                                </div>
                            </div>

                            <div class="frankli-form-group frankli-form-group-filled frankli-form-group-placeholder-shown"
                                 [class.frankli-form-group-invalid]="setupSubmitted && (controlClientId.invalid || setupClientIdInvalid)">
                                <label for="clientId">Client Id</label>
                                <input id="clientId" placeholder="Paste Client Id here" class="form-control" type="text"
                                       [formControl]="controlClientId">
                                <div class="frankli-form-group-alert">
                                    <ng-container
                                            *ngIf="(controlClientId.invalid || setupClientIdInvalid) && setupSubmitted">
                                        <div *ngIf="controlClientId.hasError('required')">Client Id is required</div>
                                        <div *ngIf="setupClientIdInvalid">{{setupApiKeyInvalid}}</div>
                                    </ng-container>
                                </div>
                            </div>

                            <div class="text-center">
                                <button type="button" class="btn-frankli-round btn-frankli-cancel"
                                        (click)="cancelUpdate()">
                                    <span>Cancel</span>
                                </button>
                                <span class="m-right-5"></span>
                                <button class="btn-frankli-round btn-frankli-green" [disabled]="setupCompleting"
                                        (click)="saveApiKey()">
                                    <span>Update</span>
                                    <span *ngIf="setupCompleting" class="m-left-10 fal fa-spin fa-spinner fa-fw"></span>
                                </button>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
            </div>

            <div class="card" *ngIf="state ===  eWorkflowState.UPDATE_REFRESH_TOKEN">
                <div class="content">
                    <div class="text-left p-bottom-5">
                        <h4 class="m-top-0 m-bottom-0">Link admin account</h4>
                    </div>

                    <div>
                        <span>Next, you need to login with your Vincere Admin account.</span>
                    </div>

                    <div class="text-center p-top-20">
                        <button class="btn-frankli-round btn-frankli-green" [disabled]="setupConnecting"
                                (click)="connectToVincere()">
                            <span>Connect my account</span>
                            <span *ngIf="setupConnecting" class="m-left-10 fal fa-spin fa-spinner fa-fw"></span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>